import { Controller } from '@hotwired/stimulus';

export default class TaxationController extends Controller {
  static targets = ['submitButton'];

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
    }
  }

  toggleSubmit(event) {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = event.target.files.length === 0;
  }
}
